import instanceRequest, {Request} from "./Request";
import {AxiosResponse} from "axios";

export const ENDPOINTS = {
  OPTIONS: {
    NETWORK_TYPES: '/api/options/network-types',
    INTERVENTION_TYPES: '/api/options/intervention-types',
    INTERVENTION_TOWNS: '/api/options/intervention-towns',
  }
} as const;

type OptionsEndpoint = typeof ENDPOINTS.OPTIONS[keyof typeof ENDPOINTS.OPTIONS];

class ReferenceDataService {

  private axiosService: Request;

  public constructor(axiosService: Request) {
    this.axiosService = axiosService;
  }

  public async getOptions(endpoints: OptionsEndpoint): Promise<string[]> {
    const response: AxiosResponse = await this.axiosService.get(endpoints, false);

    return response?.data ?? [];
  }
}

export default new ReferenceDataService(instanceRequest);
